import { useEffect } from "react";
import { useUser } from "@/hooks/useUser";
import { useRouter } from "next/router";
import { captureException } from "@sentry/nextjs";
import { NEXT_PUBLIC_BREVO_CLIENT_KEY } from "@/services/brevo/constants";

const BrevoTracker = () => {
  const router = useRouter();
  const { user } = useUser();

  useEffect(() => {
    if (!user) return;

    const { firstName, lastName, email } = user;

    try {
      // Initialize Brevo
      window.Brevo = window.Brevo || [];
      const Brevo = window.Brevo;
      Brevo.push([
        "init",
        {
          client_key: NEXT_PUBLIC_BREVO_CLIENT_KEY,
        },
      ]);

      // Set user's information
      Brevo.push([
        "identify",
        {
          identifiers: {
            email_id: email,
          },
          attributes: {
            FIRSTNAME: firstName,
            LASTNAME: lastName,
          },
        },
      ]);
    } catch (error) {
      console.error(error);
      captureException(error);
    }
  }, [user]);

  useEffect(() => {
    const handleRouteChangeComplete = (url) => {
      try {
        const Brevo = window.Brevo || [];
        Brevo.push(["page", document.title]);
      } catch (error) {
        console.error(error);
        captureException(error);
      }
    };
    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    // Cleanup
    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  return null;
};

export default BrevoTracker;
